import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import CountryBox from "components/wizard/serverWizardComponents/CountryBox";

import { ILocations } from "types/api/serversApiInterface";

const CCountry = ({
 locationList,
 location,
 setData
}: {
 locationList: Array<ILocations>;
 location: number;
 setData: (section: string, value: string | number | boolean | ILocations) => void;
}): ReactElement => {
 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2, textAlign: "left" }}>
   <Typography variant="unboundedTitle" fontSize={18}>
    <FormattedMessage id="addons.cloudbucket.selectBucketLocation" />
   </Typography>
   <Stack spacing={2} mt={2}>
    <Typography textAlign="left" variant="subtitle2">
     <FormattedMessage id="addons.cloudbucket.selectBucketLocationMessage" />
    </Typography>
    <CountryBox
     locationList={locationList}
     selectLocation={(location) => {
      setData("location", location);
      setData("serverSize", 0);
     }}
     selectedLocation={location}
    />
   </Stack>
  </Paper>
 );
};

export default CCountry;
